
define(
  'PriceMatch',
  [
    'PriceMatch.Button.View'
  ],
  function (
    PriceMatchButtonView
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {
        var pdp = container.getComponent('PDP');

        if (pdp) {
          pdp.addChildViews(
            pdp.PDP_FULL_VIEW,
            {
              PriceMatch: {
                PriceMatchButtonView: {
                  childViewIndex: 1,
                  childViewConstructor: function () {
                    var pdpItemInfo = pdp.getItemInfo();
                    var item = pdpItemInfo.item;
                    return new PriceMatchButtonView({ application: container, item: item });
                  }
                }
              }
            }
          );
        }
      }
    };
  }
);
